import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./asset/css/bootstrap.min.css";
import "./asset/css/fontawesome-all.css";
import "./asset/css/styles.css";
import "./asset/css/rtl.css";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);